/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Button,
  Dropdown,
  Image,
  InputNumber,
  Table,
  TableColumnsType,
} from "antd";
import { useRef, useState } from "react";
import { MoreOutlined } from "@ant-design/icons";
import EmptyCard from "../../../../../../../atoms/EmptyCard";
import { SubServiceType } from "../../../../../../PotentialDeals/ducks/types";

interface PropsType {
  tableId: string;
  materialData: any[] | null;
  serviceLineId: string;
  groupedData: any;
  onClose: () => void;
  setGroupedData: React.Dispatch<React.SetStateAction<any>>;
}

export default function MaterialModal(props: PropsType) {
  const { materialData, setGroupedData, serviceLineId, tableId } = props;
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);

  const [tableRecord, setTableRecord] = useState<SubServiceType | null>(null);
  const dropdownRef = useRef<HTMLButtonElement>(null);

  const currentMaterialData =
    materialData?.find(
      (e: { entity_id: string }) => e?.entity_id === tableId
    ) || [];

  let totalMatCost = 0;
  let totalMatPrice = 0;

  currentMaterialData?.material?.forEach((mat: any) => {
    totalMatCost += mat?.total_cost || 0;
    totalMatPrice += mat?.total_price || 0;
  });

  const items = [
    {
      key: "1",
      label: (
        <Button
          type="text"
          className="no-hover"
          icon={<Image src="/images/table/edit-icon.svg" preview={false} />}
          onClick={(e) => {
            e.stopPropagation();
            if (dropdownRef.current) {
              dropdownRef?.current?.click();
            }
          }}
        >
          Edit
        </Button>
      ),
    },
    {
      key: "2",
      label: (
        <Button
          type="text"
          className="no-hover"
          icon={
            <Image
              src={`/images/table/${
                tableRecord?.status === "active" ? "archive" : "activate"
              }-icon.svg`}
              preview={false}
            />
          }
          onClick={(e) => {
            e.stopPropagation();

            if (dropdownRef.current) {
              dropdownRef?.current?.click(); // Simulate a click to close
            }
          }}
        >
          {tableRecord?.status === "active" ? "Archive" : "Activate"}
        </Button>
      ),
    },
    {
      key: "3",
      label: (
        <Button
          type="text"
          className="delete-hover"
          icon={<Image src="/images/table/delete-icon.svg" preview={false} />}
          onClick={(e) => {
            e.stopPropagation();
            if (dropdownRef.current) {
              dropdownRef?.current?.click(); // Simulate a click to close
            }
          }}
        >
          Delete
        </Button>
      ),
    },
  ];

  console.log("materialData", currentMaterialData);

  const columns: TableColumnsType<SubServiceType> = [
    {
      title: "Material",
      dataIndex: "name",
      width: 439,
      fixed: "left",
      sorter: (a, b) =>
        (a?.name ?? "").toString().localeCompare((b?.name ?? "").toString()),
      render: (text) => text ?? "-",
    },
    {
      title: "Use rate",
      dataIndex: "use_rate",
      width: 150,
      align: "right",
      render: (text, record) => {
        console.log("text", text);
        return (
          <InputNumber
            value={text ?? 0}
            min={0}
            style={{
              textAlign: "right",
            }}
            className={
              text > 0 ? "subServiceInput" : "showYellow subServiceInput"
            }
            controls={false}
            // onClick={(e) => e.stopPropagation()}
            onChange={(useRate) => {
              setGroupedData((prevData: any) => {
                return prevData.map((serviceLine: any) => {
                  if (serviceLine.service_line_id === serviceLineId) {
                    return {
                      ...serviceLine,
                      service_groups: serviceLine?.service_groups?.map(
                        (group: { id: string; services: [] }) => {
                          return {
                            ...group,
                            services: group.services.map(
                              (service: {
                                material: [];
                                qty: number;
                                frequency: string;
                                visit: number;
                              }) => {
                                return {
                                  ...service,
                                  material: service?.material?.map(
                                    (mat: any) => {
                                      if (mat.id === record?.id) {
                                        let totalNeed = 0;
                                        if (service?.frequency === "one_time") {
                                          totalNeed = service?.qty / useRate;
                                        } else {
                                          totalNeed =
                                            service?.qty *
                                            useRate *
                                            service?.visit;
                                        }
                                        return {
                                          ...mat,
                                          use_rate: useRate || 0,
                                          total_need: totalNeed,

                                          total_cost:
                                            totalNeed * mat?.unit_cost,

                                          total_price:
                                            totalNeed * mat?.unit_price,
                                        };
                                      } else {
                                        return mat;
                                      }
                                    }
                                  ),
                                };
                              }
                            ),
                          };
                        }
                      ),
                    };
                  }
                  return serviceLine;
                });
              });
            }}
          />
        );
      },
    },
    {
      title: "Total need",
      dataIndex: "total_need",
      width: 150,
      align: "right",
      render: (text) =>
        text ? Number(text.toFixed(2) || 0).toLocaleString() : 0,
    },
    {
      title: "Unit cost",
      dataIndex: "unit_cost",
      width: 142,
      align: "right",
      render: (text, record) => {
        return (
          <InputNumber
            value={text.toFixed(2).toLocaleString() ?? 0}
            min={0}
            style={{
              textAlign: "right",
            }}
            className={
              text > 0 ? "subServiceInput" : "showYellow subServiceInput"
            }
            addonBefore={<span>$</span>}
            controls={false}
            // onClick={(e) => e.stopPropagation()}
            onChange={(newCost) => {
              setGroupedData((prevData: any) => {
                return prevData.map((serviceLine: any) => {
                  if (serviceLine.service_line_id === serviceLineId) {
                    return {
                      ...serviceLine,
                      service_groups: serviceLine?.service_groups?.map(
                        (group: { id: string; services: [] }) => {
                          return {
                            ...group,
                            services: group.services.map(
                              (service: { material: []; qty: number }) => {
                                return {
                                  ...service,
                                  material: service?.material?.map(
                                    (mat: any) => {
                                      if (mat.id === record?.id) {
                                        const unitPrice =
                                          (newCost * 100) /
                                          (100 - mat?.gross_margin_perc || 0);
                                        return {
                                          ...mat,
                                          unit_price: unitPrice || 0,
                                          total_cost: mat?.total_need * newCost,
                                          total_price:
                                            mat?.total_need * unitPrice,
                                          unit_cost: newCost || 0,
                                        };
                                      } else {
                                        return mat;
                                      }
                                    }
                                  ),
                                };
                              }
                            ),
                          };
                        }
                      ),
                    };
                  }
                  return serviceLine;
                });
              });
            }}
          />
        );
      },
    },
    {
      title: "Unit price",
      dataIndex: "unit_price",
      width: 142,
      align: "right",
      render: (text) =>
        text ? `$ ${Number(text.toFixed(2) || 0).toLocaleString()}` : 0,
    },
    {
      title: "Total cost",
      dataIndex: "total_cost",
      width: 127,
      align: "right",
      render: (text) =>
        text ? `$ ${Number(text.toFixed(2) || 0).toLocaleString()}` : 0,
    },
    {
      title: "Total price",
      dataIndex: "total_price",
      width: 127,
      align: "right",
      render: (text) =>
        text ? `$ ${Number(text.toFixed(2) || 0).toLocaleString()}` : 0,
    },
    {
      title: "Material GM",
      dataIndex: "gross_margin_perc",
      width: 130,
      align: "right",
      render: (text, record) => {
        return (
          <InputNumber
            value={text ?? 0}
            min={0}
            style={{
              textAlign: "right",
            }}
            className={
              text > 0 ? "subServiceInput" : "showYellow subServiceInput"
            }
            addonAfter={<span>%</span>}
            controls={false}
            // onClick={(e) => e.stopPropagation()}
            max={99}
            onChange={(newGM) => {
              setGroupedData((prevData: any) => {
                return prevData.map((serviceLine: any) => {
                  if (serviceLine.service_line_id === serviceLineId) {
                    return {
                      ...serviceLine,
                      service_groups: serviceLine?.service_groups?.map(
                        (group: { id: string; services: [] }) => {
                          return {
                            ...group,
                            services: group.services.map(
                              (service: { material: []; qty: number }) => {
                                console.log("qty", service.qty);
                                return {
                                  ...service,
                                  material: service?.material?.map(
                                    (mat: any) => {
                                      if (mat.id === record?.id) {
                                        const unitPrice =
                                          (mat?.unit_cost * 100) /
                                          (100 - newGM || 0);
                                        return {
                                          ...mat,
                                          unit_price: unitPrice || 0,
                                          gross_margin_perc: newGM || 0,
                                          total_price:
                                            mat?.total_need * unitPrice,
                                        };
                                      } else {
                                        return mat;
                                      }
                                    }
                                  ),
                                };
                              }
                            ),
                          };
                        }
                      ),
                    };
                  }
                  return serviceLine;
                });
              });
            }}
          />
        );
      },
    },
    {
      title: <Image src="/images/table/menu-burger.svg" preview={false} />,
      dataIndex: "action",
      width: 52,
      fixed: "right",
      render: (_text, record) => (
        <Dropdown
          menu={{
            items,
          }}
          trigger={["click"]}
          placement="bottomRight"
          className="actionButton"
        >
          <Button
            onClick={(e) => {
              setTableRecord(record);
              e.stopPropagation();
            }}
            onKeyDown={(e) => e.stopPropagation()}
            style={{
              padding: "6px",
              height: "auto",
              background: "transparent",
            }}
            className="only_icon"
            icon={<MoreOutlined />}
            ref={dropdownRef}
          />
        </Dropdown>
      ),
    },
  ];

  // const deleteFunction = () => {
  //   setLoading(true);

  // };

  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
    type: "checkbox" as const,
  };

  return (
    <>
      <h2 style={{ marginBottom: 4 }}>{currentMaterialData?.material?.name}</h2>
      <p style={{ marginBottom: 16 }}>
        Proposal: Maintenance Standard - Warm Season
      </p>

      {/* <Alert
        message={
          <>
            This service uses a broad material category in its template. For
            accurate pricing, choose specific material below.
            <br />
            <br />
            Otherwise, you can leave it as is and select the material during
            ordering - the price shown here will be an average price of all the
            materials in that category.
          </>
        }
        type="warning"
        style={{ background: "#E7EAFF", marginBottom: 16, width: "800px" }}
        showIcon
        icon={<Image src="/images/estimate/alert-icon.svg" preview={false} />}
      /> */}

      {!currentMaterialData?.material ? (
        <div className="empty_wrap">
          <EmptyCard
            imageHeight={70}
            title="There are no materials"
            description=""
            image="/images/empty-icons/no-archived.svg"
          />
        </div>
      ) : (
        <Table
          rowSelection={rowSelection}
          columns={columns}
          dataSource={currentMaterialData?.material || []}
          scroll={{ x: "max-content" }}
          pagination={false}
          rowKey="index"
          summary={() => (
            <Table.Summary fixed="bottom">
              <Table.Summary.Row>
                <Table.Summary.Cell index={0} colSpan={6}>
                  Total
                </Table.Summary.Cell>
                <Table.Summary.Cell index={1} align="right">
                  {totalMatCost
                    ? `$ ${Number(
                        totalMatCost.toFixed(2) || 0
                      ).toLocaleString()}`
                    : 0}
                </Table.Summary.Cell>
                <Table.Summary.Cell index={2} align="right">
                  {totalMatPrice
                    ? `$ ${Number(
                        totalMatPrice.toFixed(2) || 0
                      ).toLocaleString()}`
                    : 0}
                </Table.Summary.Cell>
                <Table.Summary.Cell index={3} />
                <Table.Summary.Cell index={4} />
              </Table.Summary.Row>
            </Table.Summary>
          )}
          sticky={{ offsetHeader: 64 }}
        />
      )}
    </>
  );
}
